import { Typography } from '@/shared/ui/atoms';

const SolutionTitle = () => {
  return (
    <div className="px-5 w-full max-w-[768px] md:max-w-[1440px] md:px-[64px] md:w-full">
      <Typography as="h2" className="text-black text-[28px] md:text-[48px] font-bold leading-[130%] md:leading-[120%] tracking-[-0.56px] md:tracking-[-0.96px]">
        리뷰웍스의 솔루션으로 <br /> <strong className="text-[#6B00D7] font-bold">병원 운영</strong>이 달라집니다.
      </Typography>
      <Typography as="h3" className="mt-4 text-[#383A4D] text-[15px] md:text-[16px] font-medium leading-[145%] tracking-[-0.075px] md:tracking-[-0.08px]">
        다양한 진료과 병원에서 리뷰웍스를 이용하고 있습니다.
      </Typography>
    </div>
  );
};

export default SolutionTitle;
